import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServiceReckoningFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServiceReckoningFormStepOne from "./ServiceReckoningFormSteps/ServiceReckoningFormStepOne";

const ServiceReckoningForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [selectedReckonings, setSelectedReckonings] = useState(_initialValues?.Reckonings || []);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val, selectedReckonings }, props)}
      validate={(val) => onValidate({ ...val, selectedReckonings }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceReckoningForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceReckoningFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceReckoningForm;
